<div class="header">
    <div class="box">?</div>
    <h1>{{'gamification.avatar_popup_header' | translate}}</h1>
</div>
<div class="body">{{'gamification.avatar_popup_body' | translate}}</div>
<button *ngIf="data?.isInSnackbar" (click)="onClick()">{{'snackbar.ok' | translate}}</button>

